function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_20",
  "data-name": "Elipse 20",
  cx: 12.543,
  cy: 12.543,
  r: 12.543,
  transform: "translate(30.66)",
  fill: "#69a9f7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_114",
  "data-name": "Trazado 114",
  d: "M2024.973,3255.576a12.419,12.419,0,0,0-3.568,8.738,12.561,12.561,0,0,0,12.543,12.542,12.376,12.376,0,0,0,6.731-1.979,32.389,32.389,0,0,1-15.707-19.3Z",
  transform: "translate(-1990.745 -3251.771)",
  fill: "#4794fb"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_115",
  "data-name": "Trazado 115",
  d: "M2066.769,3264.272a1.394,1.394,0,0,0,1.394-1.394v-.2a3.97,3.97,0,0,0-2.787-3.777v-.2a1.394,1.394,0,0,0-2.787,0v.2a3.963,3.963,0,0,0-.588,7.333l2.718,1.358a1.19,1.19,0,0,1-.532,2.255h-.407a1.192,1.192,0,0,1-1.19-1.191v-.2a1.394,1.394,0,1,0-2.787,0v.2a3.969,3.969,0,0,0,2.787,3.776v.2a1.394,1.394,0,1,0,2.787,0v-.2a3.963,3.963,0,0,0,.589-7.333l-2.718-1.359a1.19,1.19,0,0,1,.531-2.255h.407a1.192,1.192,0,0,1,1.19,1.191v.2A1.394,1.394,0,0,0,2066.769,3264.272Z",
  transform: "translate(-2020.78 -3253.124)",
  fill: "#e81687"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_116",
  "data-name": "Trazado 116",
  d: "M2065.379,3308.808a1.394,1.394,0,0,1-2.787-.027v-.21a3.961,3.961,0,0,1-2.787-3.762v-.209a1.374,1.374,0,0,1,.53-1.087A30.347,30.347,0,0,0,2065.379,3308.808Z",
  transform: "translate(-2020.783 -3289.269)",
  fill: "#a70b5a"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_97",
  "data-name": "Grupo 97",
  transform: "translate(5.575 22.298)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_216",
  "data-name": "Trazado 216",
  d: "M2.945,0H55.587a2.945,2.945,0,0,1,2.945,2.945v9.44a2.945,2.945,0,0,1-2.945,2.945H2.945A2.945,2.945,0,0,1,0,12.385V2.945A2.945,2.945,0,0,1,2.945,0Z",
  transform: "translate(8.362 0)",
  fill: "#064382"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_215",
  "data-name": "Trazado 215",
  d: "M2.945,0H54.193a2.945,2.945,0,0,1,2.945,2.945v9.44a2.945,2.945,0,0,1-2.945,2.945H2.945A2.945,2.945,0,0,1,0,12.385V2.945A2.945,2.945,0,0,1,2.945,0Z",
  transform: "translate(0 15.33)",
  fill: "#064382"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_117",
  "data-name": "Trazado 117",
  d: "M1940.992,3481.3h51.564a2.788,2.788,0,0,1,2.788,2.787v9.756a2.788,2.788,0,0,1-2.788,2.787h-54.351v-12.543A2.787,2.787,0,0,1,1940.992,3481.3Z",
  transform: "translate(-1931.237 -3450.645)",
  fill: "#064382"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_118",
  "data-name": "Trazado 118",
  d: "M1981.976,3554.491v9.756a2.8,2.8,0,0,1-2.787,2.787h-47.383V3551.7h47.383A2.8,2.8,0,0,1,1981.976,3554.491Z",
  transform: "translate(-1926.231 -3505.715)",
  fill: "#064382"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_119",
  "data-name": "Trazado 119",
  d: "M1963.344,3413.692v9.756a2.8,2.8,0,0,1-2.787,2.787v-9.755a2.8,2.8,0,0,0-2.787-2.787h-51.564a2.8,2.8,0,0,1,2.787-2.788h51.564A2.8,2.8,0,0,1,1963.344,3413.692Z",
  transform: "translate(-1900.631 -3373.276)",
  fill: "#01033a"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_120",
  "data-name": "Trazado 120",
  d: "M1995.344,3484.091v9.756a2.8,2.8,0,0,1-2.788,2.787v-9.755a2.8,2.8,0,0,0-2.787-2.788h-51.564a2.8,2.8,0,0,1,2.787-2.787h51.564A2.8,2.8,0,0,1,1995.344,3484.091Z",
  transform: "translate(-1925.662 -3428.347)",
  fill: "#01033a"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_121",
  "data-name": "Trazado 121",
  d: "M1981.976,3554.491v9.756a2.8,2.8,0,0,1-2.787,2.787v-9.755a2.8,2.8,0,0,0-2.788-2.788h-44.6V3551.7h47.383A2.8,2.8,0,0,1,1981.976,3554.491Z",
  transform: "translate(-1920.656 -3483.417)",
  fill: "#01033a"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_21",
  "data-name": "Elipse 21",
  cx: 12.543,
  cy: 12.543,
  r: 12.543,
  transform: "translate(0 58.532)",
  fill: "#69a9f7"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_122",
  "data-name": "Trazado 122",
  d: "M1884.173,3524.376a12.421,12.421,0,0,0-3.568,8.739,12.562,12.562,0,0,0,12.543,12.542,12.376,12.376,0,0,0,6.731-1.979,32.389,32.389,0,0,1-15.706-19.3Z",
  transform: "translate(-1880.605 -3462.039)",
  fill: "#4794fb"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_123",
  "data-name": "Trazado 123",
  d: "M1925.97,3533.072a1.394,1.394,0,0,0,1.393-1.394v-.2a3.968,3.968,0,0,0-2.787-3.776v-.2a1.393,1.393,0,0,0-2.787,0v.2a3.963,3.963,0,0,0-.589,7.333l2.718,1.358a1.19,1.19,0,0,1-.532,2.255h-.407a1.191,1.191,0,0,1-1.19-1.19v-.2a1.394,1.394,0,0,0-2.787,0v.2a3.969,3.969,0,0,0,2.787,3.776v.2a1.393,1.393,0,1,0,2.787,0v-.2a3.963,3.963,0,0,0,.589-7.334l-2.718-1.358a1.19,1.19,0,0,1,.532-2.255h.407a1.193,1.193,0,0,1,1.19,1.191v.2A1.394,1.394,0,0,0,1925.97,3533.072Z",
  transform: "translate(-1910.64 -3463.391)",
  fill: "#e81687"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_124",
  "data-name": "Trazado 124",
  d: "M1924.58,3577.609a1.394,1.394,0,1,1-2.787-.029v-.208a3.961,3.961,0,0,1-2.787-3.763v-.208a1.374,1.374,0,0,1,.53-1.087,30.351,30.351,0,0,0,5.045,5.3Z",
  transform: "translate(-1910.643 -3499.537)",
  fill: "#a70b5a"
});

var SvgCoins = function SvgCoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_229",
    "data-name": "Grupo 229",
    width: 72.468,
    height: 83.618,
    viewBox: "0 0 72.468 83.618",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coins.7debaa94.svg";
export { ForwardRef as ReactComponent };